<div class="filter-container date-calender">
  <label class="filter-label"  style="font-weight: 650;">{{ data?.name }}</label>

  <!-- trigger looks like your ng-select input -->
  <button
    type="button"
    class="dc-trigger"
    (click)="togglePopover($event)"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="dialog"
  >
    <div class="custom-multi-label-wrapper">
      <ng-container *ngIf="value?.length; else dcAll">
        <div class="ng-value">
          <span
            class="ng-value-icon left"
            (click)="clearAll(); $event.stopPropagation()"
            aria-label="Clear all"
            role="button"
          >×</span>
          <span class="ng-value-label">
            {{ value[0] | date: 'yyyy-MM-dd' }}
          </span>
        </div>
        <span class="tag-summary" *ngIf="value.length > 1">
          +{{ value.length - 1 }} more
        </span>
      </ng-container>
      <ng-template #dcAll>
        <span class="dc-placeholder">All</span>
      </ng-template>
    </div>
    <span class="dc-caret">▾</span>
  </button>

  <!-- popover calendar -->
  <div
    class="dc-popover"
    *ngIf="isOpen"
    (click)="$event.stopPropagation()"
    role="dialog"
    aria-label="Calendar"
  >
    <!-- Header -->
    <div class="dc-header">
      <button type="button" class="nav-btn" (click)="prevMonth()" aria-label="Previous month">‹</button>

      <!-- Make the label clickable to open Y/M picker -->
      <button type="button" class="month-label-btn" (click)="toggleYearPicker($event)">
        {{ monthLabel }}
      </button>

      <button type="button" class="nav-btn" (click)="nextMonth()" aria-label="Next month">›</button>
    </div>

    <!-- Year/Month quick picker -->
    <div class="dc-yearpicker" *ngIf="showYearPicker" (click)="$event.stopPropagation()">
      <div class="yp-nav">
        <button type="button" class="nav-btn" (click)="shiftYears(-12)" aria-label="Previous years">‹</button>
        <div class="yp-range">{{ yearStart }}–{{ yearStart + 11 }}</div>
        <button type="button" class="nav-btn" (click)="shiftYears(12)" aria-label="Next years">›</button>
      </div>

      <div class="yp-years">
        <button
          type="button"
          class="yp-year"
          *ngFor="let y of yearGrid"
          [class.active]="y === viewYear"
          (click)="selectYear(y)"
        >
          {{ y }}
        </button>
      </div>

      <div class="yp-months">
        <button
          type="button"
          class="yp-month"
          *ngFor="let m of monthShort; let i = index"
          [class.active]="i === viewMonth"
          (click)="selectMonth(i)"
        >
          {{ m }}
        </button>
      </div>
    </div>

    <!-- Weekday headings -->
    <div class="dc-weekdays" *ngIf="!showYearPicker">
      <div class="dc-weekday" *ngFor="let wd of weekDayLabels">{{ wd }}</div>
    </div>

    <!-- Calendar grid -->
    <div class="dc-weeks" *ngIf="!showYearPicker">
      <div class="dc-week" *ngFor="let week of weeks">
        <button
          type="button"
          class="dc-day"
          *ngFor="let cell of week"
          [class.outside]="!cell.inCurrentMonth"
          [class.selected]="cell.selected"
          [disabled]="cell.disabled"
          (click)="onDayClick(cell)"
        >
          <span class="dc-day-inner">{{ cell.date.getDate() }}</span>
        </button>
      </div>
    </div>

    <!-- Footer actions -->
    <div class="dc-actions" *ngIf="!showYearPicker">
      <button type="button" class="link-btn" (click)="goToToday()">Today</button>
      <span class="spacer"></span>
      <button type="button" class="link-btn danger" (click)="clearAll()">Clear All</button>
    </div>
  </div>
</div>
